export default __webpack_public_path__ + "static/media/icon-chevron-left.5a5864ab.svg";